import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerFacebookPageAnalyticsPost.graphql';
import { Query, QueryinfluencerFacebookPageAnalyticsPostArgs } from '../../__generated__/globalTypes';

export const useInfluencerFacebookPageAnalyticsPostQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerFacebookPageAnalyticsPostLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>
): QueryResult<Query, QueryinfluencerFacebookPageAnalyticsPostArgs> & {
  getInfluencerFacebookPageAnalyticsPost: LazyQueryExecFunction<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerFacebookPageAnalyticsPost, result] = useLazyQuery<
    Query,
    QueryinfluencerFacebookPageAnalyticsPostArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerFacebookPageAnalyticsPost, ...result };
};

export const useInfluencerFacebookPageAnalyticsPostPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerFacebookPageAnalyticsPost = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerFacebookPageAnalyticsPostArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerFacebookPageAnalyticsPost };
};
// Suspense Query Hooks
export const useInfluencerFacebookPageAnalyticsPostSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerFacebookPageAnalyticsPostArgs>(QUERY, {
    ...options
  });

  return result;
};
